
function DayFour({content}) {

    window.document.body.style.backgroundColor = "#FFFCF9";
    window.document.body.style.color = "#16324f";

  return (
    <div className="day place-items-center content-center" id="dayfour">
    
                <div className="m-10 p-4 text-4xl lg:text-5xl" >Türchen 4</div>
    <div className="text-xl content-center w-11/12 md:w-1/2 place-items-center">
    <div className="place-items-center w-11/12 lg:w-1/2">
    <div className="pb-5">
    Beantwortet zusammen:<br/><br/>
    Welche Herausforderung hat dich dieses Jahr am meisten wachsen lassen?

    </div>
      </div>
   </div>
    </div>

  );
}

export default DayFour;